import Vue from "vue";
import Router from "vue-router";
import store from './store';

Vue.use(Router);

//일진머티리얼즈 Router
const routes_mt = [
  {
    path: '/slo/:userNo',
    name: 'Slo',
    props: true,
    component: () =>
        import ('./views/login/Slo.vue'),
  },
  {
    path: "/ijmt/visitRequest",
    name: "visitRequestMt",
    component: () => import("./views/mt/visitorbook/VisitRequest.vue"),
    props: true,
  },
  {
    path: "/ijmt/visitRequestProposal",
    name: "visitRequestProposal",
    component: () => import("./views/mt/visitorbook/VisitRequestProposal.vue"),
  },
  {
    path: "/ijmt",
    name: "visitorMain",
    component: () => import("./views/mt/VisitorMain.vue"),
  },
  {
    name: "visitReserveMt",
    path: "/ijmt/visitReserve",
    component: () => import("./views/mt/VisitReserve.vue"),
    props: true,
  },
  {
    path: "/ijmt/visitProposal",
    name: "visitProposal",
    component: () => import("./views/mt/VisitProposal.vue"),
  },
  {
    path: "/ijmt/visitStatus",
    name: "visitStatus",
    component: () => import("./views/mt/VisitStatus.vue"),
  },
  {
    path: "/ijmt/visitTerms",
    name: "visitTerms",
    component: () => import("./views/mt/VisitTerms.vue"),
  },
  {
    path: "/ijmt/visitPolicy",
    name: "visitPolicy",
    component: () => import("./views/mt/VisitPolicy.vue"),
  },
  {
    path: "/ijmt/board/notice",
    name: "noticeList",
    component: () => import("./views/mt/board/BoardListVisitor.vue"),
  },
  {
    path: "/ijmt/board/faq",
    name: "faqList",
    component: () => import("./views/mt/board/BoardListVisitor.vue"),
  },
  {
    path: "/ijmt/board/notice/detail/:contentId",
    name: "noticeDetail",
    props: true,
    component: () => import("./views/mt/board/BoardDetailVisitor.vue"),
  },
  {
    path: "/ijmt/board/faq/detail/:contentId",
    name: "faqDetail",
    props: true,
    component: () => import("./views/mt/board/BoardDetailVisitor.vue"),
  },
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/loginM",
      name: "LoginManual",
      props: true,
      component: () => import("./components/LoginManual.vue"),
    },

    // 머티리얼즈 소스 분리를 위해 "/" 경로 이동시 ijmt 로 이동
    // {
    //   path: "/",
    //   name: "groupMain",
    //   component: () => import("./views/GroupMain.vue"),
    // },
    {
      path: "/",
      redirect: "/ijmt",
    },

    {
      path: "/login",
      name: "Login",
      props: true,
      component: () => import("./components/Login.vue"),
    },
    {
      path: "/visitNotice",
      name: "visitNotice",
      component: () => import("./views/VisitNotice.vue"),
    },
    {
      path: "/visitFaq",
      name: "visitFaq",
      component: () => import("./views/VisitFaq.vue"),
    },
    {
      path: "/backOffice",
      name: "main",
      component: () => import("./views/MyMain.vue"),
    },
    {
      path: "/backOffice/quickSetting",
      name: "quickSetting",
      component: () => import("./views/QuickSetting.vue"),
    },
    {
      path: "/backOffice/apprPendLst",
      name: "apprPendLst",
      component: () => import("./views/ApprPendLst.vue"),
    },
    {
      path: "/backOffice/apprDtlQry/:docMngNo",
      name: "apprDtlQry",
      props: true,
      component: () => import("./views/ApprDtlQry.vue"),
    },
    {
      path: "/backOffice/apprCompLst",
      name: "apprCompLst",
      component: () => import("./views/ApprCompLst.vue"),
    },
    {
      path: "/backOffice/apprReqLst",
      name: "apprReqLst",
      component: () => import("./views/ApprReqLst.vue"),
    },
    {
      path: "/backOffice/apprDropLst",
      name: "apprDropLst",
      component: () => import("./views/ApprDropLst.vue"),
    },
    {
      path: "/backOffice/apprReferLst",
      name: "apprReferLst",
      component: () => import("./views/ApprReferLst.vue"),
    },
    {
      path: "/backOffice/apprMndSet",
      name: "apprMndSet",
      component: () => import("./views/ApprMndSet.vue"),
    },
    {
      path: "/backOffice/apprRuleSet",
      name: "apprRuleSet",
      component: () => import("./views/ApprRuleSet.vue"),
    },
    {
      path: "/backOffice/authMng",
      name: "authMng",
      component: () => import("./views/AuthMng.vue"),
    },
    {
      path: "/backOffice/pgmMng",
      name: "pgmMng",
      component: () => import("./views/PgmMng.vue"),
    },
    {
      path: "/backOffice/funcMng",
      name: "funcMng",
      component: () => import("./views/FuncMng.vue"),
    },
    {
      path: "/backOffice/termsListMng",
      name: "termsListMng",
      component: () => import("./views/TermsListMng.vue"),
    },
    {
      path: "/backOffice/terms/create",
      name: "termsCreate",
      props: true,
      component: () => import("./views/TermsCreate.vue"),
    },
    {
      path: "/backOffice/terms/detail/:contentId",
      name: "termsDetail",
      props: true,
      component: () => import("./views/TermsDetail.vue"),
    },
    {
      path: "/backOffice/codeMng",
      name: "codeMng",
      component: () => import("./views/CodeMng.vue"),
    },
    {
      path: "/backOffice/visitList",
      name: "visitList",
      component: () => import("./views/VisitList.vue"),
    },
    {
      path: "/backOffice/visitMgList",
      name: "visitMgList",
      component: () => import("./views/VisitMgList.vue"),
    },
    {
      path: "/backOffice/visitMng/:visitNo",
      name: "visitMng",
      props: true,
      component: () => import("./views/VisitMng.vue"),
    },
    {
      path: "/backOffice/visitMngMg/:visitNo",
      name: "visitMngMg",
      props: true,
      component: () => import("./views/VisitMngMg.vue"),
    },
    {
      path: "/backOffice/visitMngList",
      name: "visitMngList",
      component: () => import("./views/VisitMngList.vue"),
    },
    {
      path: "/backOffice/visitMngMgList",
      name: "visitMngMgList",
      component: () => import("./views/VisitMngMgList.vue"),
    },
    {
      path: "/backOffice/visitControlMng/:visitNo",
      name: "visitControlMng",
      props: true,
      component: () => import("./views/VisitControlMng.vue"),
    },
    {
      path: "/backOffice/visitControlMgMng/:visitNo",
      name: "visitControlMgMng",
      props: true,
      component: () => import("./views/VisitControlMgMng.vue"),
    },
    {
      path: "/backOffice/visitorIngList",
      name: "visitorIngList",
      component: () => import("./views/VisitorIngList.vue"),
    },
    {
      path: "/backOffice/visitorIngMgList",
      name: "visitorIngMgList",
      component: () => import("./views/VisitorIngMgList.vue"),
    },
    {
      path: "/backOffice/visitStatisticsPeriod",
      name: "VisitStatisticsPeriod",
      props: true,
      component: () => import("./views/VisitStatisticsPeriod.vue"),
    },
    {
      path: "/backOffice/visitStatisticsPeriodMg",
      name: "VisitStatisticsPeriodMg",
      props: true,
      component: () => import("./views/VisitStatisticsPeriodMg.vue"),
    },

    {
      path: "/backOffice/visitStatist",
      name: "visitStatist",
      props: true,
      component: () => import("./views/VisitStatisticsDept.vue"),
    },
    {
      path: "/backOffice/visitStatisticsDept",
      name: "VisitStatisticsDept",
      props: true,
      component: () => import("./views/VisitStatisticsDept.vue"),
    },
    {
      path: "/backOffice/visitStatisticsDeptMg",
      name: "VisitStatisticsDeptMg",
      props: true,
      component: () => import("./views/VisitStatisticsDeptMg.vue"),
    },
    {
      path: "/backOffice/visitStatisticsCategory",
      name: "VisitStatisticsCategory",
      props: true,
      component: () => import("./views/VisitStatisticsCategory.vue"),
    },
    {
      path: "/backOffice/visitStatisticsCategoryMg",
      name: "VisitStatisticsCategoryMg",
      props: true,
      component: () => import("./views/VisitStatisticsCategoryMg.vue"),
    },
    {
      path: "/backOffice/visitSecuItemList",
      name: "visitSecuItemList",
      component: () => import("./views/VisitSecuItemList.vue"),
    },
    {
      path: "/backOffice/visitCarList",
      name: "visitCarList",
      component: () => import("./views/VisitCarList.vue"),
    },
    {
      path: "/backOffice/blackList",
      name: "blackList",
      component: () => import("./views/BlackList.vue"),
    },
    {
      path: "/backOffice/blackListMg",
      name: "blackListMg",
      component: () => import("./views/BlackListMg.vue"),
    },
    {
      path: "/backOffice/VehicleList",
      name: "VehicleList",
      component: () => import("./views/VehicleList.vue"),
    },
    {
      path: "/backOffice/visitSecuItemMgList",
      name: "visitSecuItemMgList",
      component: () => import("./views/VisitSecuItemMgList.vue"),
    },
    {
      path: "/ijmg/visitRequest",
      name: "visitRequestMg",
      component: () => import("./views/mg/visitorbook/VisitRequest.vue"),
      props: true,
    },
    {
      path: "/ijmg/visitRequestProposal",
      name: "visitRequestProposal",
      component: () =>
        import("./views/mg/visitorbook/VisitRequestProposal.vue"),
    },
    {
      path: "/backOffice/board/notice",
      name: "noticeList",
      component: () => import("./views/mt/board/BoardList.vue"),
    },
    {
      path: "/backOffice/board/faq",
      name: "faqList",
      component: () => import("./views/mt/board/BoardList.vue"),
    },
    {
      path: "/backOffice/board/notice/create",
      name: "noticeCreate",
      props: true,
      component: () => import("./views/mt/board/BoardCreate.vue"),
    },
    {
      path: "/backOffice/board/notice/detail/:contentId",
      name: "noticeDetail",
      props: true,
      component: () => import("./views/mt/board/BoardDetail.vue"),
    },
    {
      path: "/backOffice/board/notice/modify",
      name: "noticeModifyMt",
      props: true,
      component: () => import("./views/mt/board/BoardCreate.vue"),
    },
    {
      path: "/backOffice/board/faq/create",
      name: "faqCreate",
      props: true,
      component: () => import("./views/mt/board/BoardCreate.vue"),
    },
    {
      path: "/backOffice/board/faq/detail/:contentId",
      name: "faqDetail",
      props: true,
      component: () => import("./views/mt/board/BoardDetail.vue"),
    },
    {
      path: "/backOffice/board/faq/modify",
      name: "faqModifyMt",
      props: true,
      component: () => import("./views/mt/board/BoardCreate.vue"),
    },
  ]
    .concat(routes_mt),
});

export default router;